import { apiClient } from '../../axios';
import {
  ConversionRateParams,
  GetBonusExpireStatusResponse,
  GetConversionLimitResponse,
  GetConversionRateResponse,
  GetDepositNetworksByCurrencyResponse,
  GetMyAddressParams,
  GetMyAddressResponse,
  GetPendingCountResponse,
  GetTravelRuleProofInfoResponse,
  GetTravelRuleProofTransferResponse,
  GetWithdrawalAddressBookNetworksUniversalResponse,
  GetWithdrawalAddressBookParams,
  GetWithdrawalAddressBookResponse,
  GetWithdrawalBalanceParams,
  GetWithdrawalBalanceResponse,
  GetWithdrawalSettingsResponse,
  PostConversionConfirmParams,
  PostConversionInitiateParams,
  PostConversionResponse,
  PostTravelRuleProofParams,
  PostTravelRuleProofUploadParams,
  PostTravelRuleProofUploadResponse,
  PostWithdrawalAddressBookParams,
  PostWithdrawalAddressBookResponse,
  PostWithdrawalConfirmParams,
  PostWithdrawalInitiateResponse,
  PostWithdrawalInitiateparams,
  PutWithdrawalAddressBookParams,
  PutWithdrawalSettingsParams,
} from './type';

export const postWalletConfirmApi = (params: { code: string }) => apiClient.post('/v1/wallet/confirm', params);

export const deleteWalletWithdrawalApi = (id: string) => apiClient.delete('/v1/wallet/withdrawal', { params: { id } });

export const getMyAddressApi = (params: GetMyAddressParams) =>
  apiClient.get<GetMyAddressResponse>('/v1/wallet/address', { params });

export const getWithdrawalBalanceApi = (params: GetWithdrawalBalanceParams) =>
  apiClient.get<GetWithdrawalBalanceResponse>('/v1/wallet/withdrawal', { params });

export const postWithdrawalInitiateApi = (params: PostWithdrawalInitiateparams) =>
  apiClient.post<PostWithdrawalInitiateResponse>('/v1/wallet/withdrawal/initiate', params);

export const postWithdrawalConfirmApi = (params: PostWithdrawalConfirmParams) =>
  apiClient.post<{ id: string }>('/v1/wallet/withdrawal/confirm', params);

export const getConversionLimitApi = (fromCurrency: string, toCurrency: string) =>
  apiClient.get<GetConversionLimitResponse>('/v1/conversion/limit', { params: { fromCurrency, toCurrency } });

export const postConversionInitiateApi = (params: PostConversionInitiateParams) =>
  apiClient.post<PostConversionResponse>('/v1/conversion/initiate', params);

export const postConversionConfirmApi = (params: PostConversionConfirmParams) =>
  apiClient.post('/v1/conversion/confirm', params);

export const getConversionRateApi = (params: ConversionRateParams) =>
  apiClient.get<GetConversionRateResponse>('/v1/conversion/preview', { params });

export const postConversionExecuteApi = (params: ConversionRateParams) =>
  apiClient.post<PostConversionResponse>('/v1/conversion/execute', params);

export const getDepositRecommendedCurrencies = () =>
  apiClient.get<{ recommendedCurrencies: string[] }>('/v1/deposit/recommended-currencies');

export const getDepositNetworksByCurrencyApi = (currency: string) =>
  apiClient.get<GetDepositNetworksByCurrencyResponse>(`/v1/deposit/${currency}/networks`);

export const getDepositNetworksApi = () => apiClient.get<GetDepositNetworksByCurrencyResponse>('/v1/deposit/networks');

export const getWithdrawalAddressApi = (params: GetWithdrawalAddressBookParams) =>
  apiClient.get<GetWithdrawalAddressBookResponse>('/v1/wallet/withdrawal/address-book', { params });

export const postWithdrawalAddressBookApi = (params: PostWithdrawalAddressBookParams) =>
  apiClient.post<PostWithdrawalAddressBookResponse>('/v1/wallet/withdrawal/address-book', params);

export const putWithdrawalAddressBookApi = (id: number, params: PutWithdrawalAddressBookParams) =>
  apiClient.put(`/v1/wallet/withdrawal/address-book/${id}`, params);

export const deleteWithdrawalAddressBookApi = (id: number) =>
  apiClient.delete(`/v1/wallet/withdrawal/address-book/${id}`);

export const getWithdrawalSettingsApi = () =>
  apiClient.get<GetWithdrawalSettingsResponse>('/v1/wallet/withdrawal/setting');

export const putWithdrawalSettingsApi = (params: PutWithdrawalSettingsParams) =>
  apiClient.put('/v1/wallet/withdrawal/setting', params);

export const getPendingCountApi = () => apiClient.get<GetPendingCountResponse>('/v1/wallet/pending');

export const getBonusExpireStatusApi = () =>
  apiClient.get<GetBonusExpireStatusResponse>('/v1/wallet/bonus-expire/status');

export const getWithdrawalAddressBookNetworksUniversalApi = () =>
  apiClient.get<GetWithdrawalAddressBookNetworksUniversalResponse>(
    '/v1/wallet/withdrawal/address-book/networks/universal',
  );

export const getTravelRuleProofInfoApi = () =>
  apiClient.get<GetTravelRuleProofInfoResponse>('/v1/wallet/travel-rule-proof/info');

export const postTravelRuleProofUploadApi = (params: PostTravelRuleProofUploadParams) =>
  apiClient.post<PostTravelRuleProofUploadResponse>('/v1/wallet/travel-rule-proof/upload', params);

export const postWithdrawalTravelRuleProofApi = (id: string, params: PostTravelRuleProofParams) =>
  apiClient.post(`/v1/wallet/withdrawal/${id}/travel-rule-proof`, params);

export const postDepositTravelRuleProofApi = (id: string, params: PostTravelRuleProofParams) =>
  apiClient.post(`/v1/wallet/deposit/${id}/travel-rule-proof`, params);

export const getTravelRuleProofTransferApi = (id: string) =>
  apiClient.get<GetTravelRuleProofTransferResponse>(`/v1/wallet/transfers/${id}`);
